class Logger {
    logError(error) {
        console.log(error);
    }
}

const logger = new Logger();
export default logger;
